// @flow

export const LOGIN_REQUEST = 'User/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'User/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'User/LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'User/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'User/LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'User/LOGOUT_FAILURE';

export const USER_PROFILE_REQUEST = 'User/USER_PROFILE_REQUEST';
export const USER_PROFILE_SUCCESS = 'User/USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAILURE = 'User/USER_PROFILE_FAILURE';

export const CHANGE_PASSWORD_REQUEST = 'User/CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'User/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'User/CHANGE_PASSWORD_FAILURE';

export const FORGOT_PASSWORD_REQUEST = 'User/FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_SUCCESS = 'User/FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_FAILURE = 'User/FORGOT_PASSWORD_FAILURE';
